import React, { useState } from 'react';

import LoadingSpinnerComponent from '../LoadingSpinnerComponent';

import { Alert, Typography } from '@mui/joy';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';

import '../../styles/alert.scss';
import { useAuth } from '../../context/authContext';

const networking = require('../../Networking/API');

function NotificationAlertComponent(app: any, style: any) {
    const { token } = useAuth();

    const [loading, setLoading] = useState(true);
    const [reviews, setReviews] = useState(null) as any[];
    const [status, setStatus] = useState('');

    var icon = status === 'severe' ? faExclamationCircle : faCheckCircle;
    var title = status === 'severe' ? 'ATTENTION' : 'ALL GOOD!';
    var message = status === 'severe' ? `There are some keywords that represent more than ${app.app.trending_threshold}% of all of your reviews. This requires your attention!` :
        'There are no significant issues detected in your app reviews. Keep up the good work! 😊';

    var a: any[] = [];
    var count = [];

    if (!reviews) {
        getData();
    } else {
        getIssues();
    }

    function getData() {
        networking.reviewsFor(app.app.id, token).then((reviews: any) => {
            setReviews(reviews);
        }).catch((error: Error) => {
            setLoading(false);
        });
    }

    function getIssues() {
        networking.issuesFor(app.app.id, token).then((issues: any) => {
            prepareAlert(issues);
            setLoading(false);
        }).catch((error: Error) => {
            setLoading(false);
        });
    }

    function prepareAlert(issues: any[]) {
        const revs = reviews;
        issues.map((issue: any) =>
            a.push({ 'r': revs.filter((r: any) => issue.keywords.some((k: string) => r.content.toLowerCase().includes(k.toLocaleLowerCase()))) })
        );

        a.forEach((element: any) => {
            const p = element.r.length / reviews.length;

            if (p * 100 > app.app.trending_threshold && element.r.length > 10) {
                count.push(p);
            }
        });

        if (count.length) {
            setStatus('severe');
        } else {
            setStatus('good');
        }
    }

    return (
        <Alert
            variant='soft'
            color={status === 'severe' ? 'danger' : 'success'}
            sx={{
                height: '100%',
            }}>

            {loading ?
                <LoadingSpinnerComponent />
                :
                <div className='my-auto mx-auto'>
                    <div className='text-center'>
                        <FontAwesomeIcon
                            icon={icon}
                            size='3x' />
                    </div>
                    <div>
                        <div className='text-center mt-3'>
                            <Typography
                                level='title-sm'
                                fontWeight={900}>
                                {title}
                            </Typography>
                        </div>
                        <div className='text-center mt-3 px-5'>
                            <Typography
                                level='body-sm'
                                fontWeight={600}>
                                {message}
                            </Typography>
                        </div>
                    </div>
                </div>
            }
        </Alert>
    );
}

export default NotificationAlertComponent;